import { token } from '@/infrastructure/container';

export interface IClock {
  now(): number;
  delay(ms: number): Promise<void>;
}

export const TOKEN_IClock = token<IClock>('IClock');

export class Clock implements IClock {
  now(): number {
    return Date.now();
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
